<template lang="pug">
  .room.prep-station-big(v-loading="loadingData")
    .divice-block-multi
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" :class="warningFlag1")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" :class="warningFlag2")
      SinglePieHistogramWrap.divice-block-multi-item(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" :class="warningFlag3")
      //- .divice-block-multi-item.multi-item-tran
      //-   SwitchStatus.divice-block-thin(title="回风机3运行" :series="SwitchStatusData13")
      //-   SwitchStatus.divice-block-thin(title="回风机3故障" :series="SwitchStatusData14")
      //-   RunningTimeBig.divice-block-time(title="回风机3运行时间" :series="RunningTimeData5")
    .divice-block-line
      .divice-block-line-item
        .divice-block-thin-wrap
          SwitchStatus.divice-block-thin(:title="frequencyConversion1" :series="SwitchStatusData1")
          SwitchStatus.divice-block-thin(:title="frequencyConversion2" :series="SwitchStatusData2")
        SwitchStatus.divice-block-thin(title="循环风机1运行" :series="SwitchStatusData3")
        SwitchStatus.divice-block-thin(title="循环风机1故障" :series="SwitchStatusData4")
        RunningTimeBig.divice-block-time(title="循环风机1运行时间" :series="RunningTimeData1")
      .divice-block-line-item
        .divice-block-thin-wrap
          SwitchStatus.divice-block-thin(:title="frequencyConversion3" :series="SwitchStatusData5")
          SwitchStatus.divice-block-thin(:title="frequencyConversion4" :series="SwitchStatusData6")
        SwitchStatus.divice-block-thin(title="循环风机2运行" :series="SwitchStatusData7")
        SwitchStatus.divice-block-thin(title="循环风机2故障" :series="SwitchStatusData8")
        RunningTimeBig.divice-block-time(title="循环风机2运行时间" :series="RunningTimeData2")
      .divice-block-line-item
        .divice-block-thin-wrap
          SwitchStatus.divice-block-thin(title="1#冷却风机故障" :series="SwitchStatusData9")
          SwitchStatus.divice-block-thin(title="2#冷却风机故障" :series="SwitchStatusData10")
        SwitchStatus.divice-block-thin(title="循环风机3运行" :series="SwitchStatusData11")
        SwitchStatus.divice-block-thin(title="循环风机3故障" :series="SwitchStatusData12")
        RunningTimeBig.divice-block-time(title="循环风机3运行时间" :series="RunningTimeData3")
      .divice-block-line-item
        SwitchStatus.divice-block-thin(title="回风机2运行" :series="SwitchStatusData15")
        SwitchStatus.divice-block-thin(title="回风机2故障" :series="SwitchStatusData16")
        RunningTimeBig.divice-block-time-big(title="回风机2运行时间" :series="RunningTimeData4")
      .divice-block-line-item
        SwitchStatus.divice-block-thin(title="回风机3运行" :series="SwitchStatusData13")
        SwitchStatus.divice-block-thin(title="回风机3故障" :series="SwitchStatusData14")
        RunningTimeBig.divice-block-time-big(title="回风机3运行时间" :series="RunningTimeData5")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/prepStationBig_data.json'

export default {
  name: 'prepStationBig',
  data() {
    return {
      timer: null,
      loadingData: false,
      deviceList: [],
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      SwitchStatusData1: null,
      SwitchStatusData2: null,
      SwitchStatusData3: null,
      SwitchStatusData4: null,
      SwitchStatusData5: null,
      SwitchStatusData6: null,
      SwitchStatusData7: null,
      SwitchStatusData8: null,
      SwitchStatusData9: null,
      SwitchStatusData10: null,
      SwitchStatusData11: null,
      SwitchStatusData12: null,
      SwitchStatusData13: null,
      SwitchStatusData14: null,
      SwitchStatusData15: null,
      SwitchStatusData16: null,
      frequencyConversion1: '',
      frequencyConversion2: '',
      frequencyConversion3: '',
      frequencyConversion4: '',
      RunningTimeData1: null,
      RunningTimeData2: null,
      RunningTimeData3: null,
      RunningTimeData4: null,
      RunningTimeData5: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapData3: null,
      SinglePieHistogramWrapOpts1: {
        title: '钢箱梁1区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts2: {
        title: '钢箱梁2区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapOpts3: {
        title: '钢箱梁3区温湿度',
        histogramName1: 'T',
        center1: ['52%', '60%'],
        radius1: ['40%', '55%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  created() {
    this.setTitles()
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  mounted() {
    this.getDatas()
    // this.getInfo()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
    },
    getInfo() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/bridge/StationInfo?stationId=${stationId}`).then(res => {
        const __data = res.data.deviceList
        const list = __data.map(el => {
          return {
            deviceId: el.deviceId,
            deviceName: el.deviceName
          }
        })
        console.log('list', JSON.stringify(list))
      })
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceName
      this.frequencyConversion1 = deviceName[0]
      this.frequencyConversion2 = deviceName[1]
      this.frequencyConversion3 = deviceName[2]
      this.frequencyConversion4 = deviceName[3]
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    setPieHisData(datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (
        datas[data2Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (
        datas[data1Id].errorLevel !== 'Normal' &&
        this[warnName] !== 'Error'
      ) {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDatas() {
      console.log('getDatas')
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceDataName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http.get(`/deviceData/Station?stationId=${stationId}`).then(res => {
        this.loadingData = false
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData1',
          this.findDeviceId('钢箱梁1区湿度(%)'),
          this.findDeviceId('钢箱梁1区温度(℃)'),
          'warningFlag1'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData2',
          this.findDeviceId('钢箱梁2区湿度(%)'),
          this.findDeviceId('钢箱梁2区温度(℃)'),
          'warningFlag2'
        )
        this.setPieHisData(
          __data,
          'SinglePieHistogramWrapData3',
          this.findDeviceId('钢箱梁3区湿度(%)'),
          this.findDeviceId('钢箱梁3区温度(℃)'),
          'warningFlag3'
        )
        this.RunningTimeData1 = __data[this.findDeviceId('循环风机1运行时间(运行时间)')].value
        this.RunningTimeData2 = __data[this.findDeviceId('循环风机2运行时间(运行时间)')].value
        this.RunningTimeData3 = __data[this.findDeviceId('循环风机3运行时间(运行时间)')].value
        this.RunningTimeData4 = __data[this.findDeviceId('回风机2运行时间(运行时间)')].value
        this.RunningTimeData5 = __data[this.findDeviceId('回风机3运行时间(运行时间)')].value
        this.SwitchStatusData1 = {
          data: __data[this.findDeviceId(deviceDataName[0])].value,
          isError: __data[this.findDeviceId(deviceDataName[0])].errorLevel,
          isZh: true
        }
        this.SwitchStatusData2 = {
          data: __data[this.findDeviceId(deviceDataName[1])].value,
          isError: __data[this.findDeviceId(deviceDataName[1])].errorLevel,
          isZh: true
        }
                this.SwitchStatusData5 = {
          data: __data[this.findDeviceId(deviceDataName[2])].value,
          isError: __data[this.findDeviceId(deviceDataName[2])].errorLevel,
          isZh: true
        }
        this.SwitchStatusData6 = {
          data: __data[this.findDeviceId(deviceDataName[3])].value,
          isError: __data[this.findDeviceId(deviceDataName[3])].errorLevel,
          isZh: true
        }
        this.SwitchStatusData3 = {
          data: __data[this.findDeviceId('循环风机1运行(开关)')].value,
          isError: __data[this.findDeviceId('循环风机1运行(开关)')].errorLevel
        }
        this.SwitchStatusData4 = {
          data: __data[this.findDeviceId('循环风机1故障(开关)')].value,
          isError: __data[this.findDeviceId('循环风机1故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData7 = {
          data: __data[this.findDeviceId('循环风机2运行(开关)')].value,
          isError: __data[this.findDeviceId('循环风机2运行(开关)')].errorLevel
        }
        this.SwitchStatusData8 = {
          data: __data[this.findDeviceId('循环风机2故障(开关)')].value,
          isError: __data[this.findDeviceId('循环风机2故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData9 = {
          data: __data[this.findDeviceId('1#冷却风机故障(开关)')].value,
          isError: __data[this.findDeviceId('1#冷却风机故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData10 = {
          data: __data[this.findDeviceId('2#冷却风机故障(开关)')].value,
          isError: __data[this.findDeviceId('2#冷却风机故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData11 = {
          data: __data[this.findDeviceId('循环风机3运行(开关)')].value,
          isError: __data[this.findDeviceId('循环风机3运行(开关)')].errorLevel
        }
        this.SwitchStatusData12 = {
          data: __data[this.findDeviceId('循环风机3故障(开关)')].value,
          isError: __data[this.findDeviceId('循环风机3故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData15 = {
          data: __data[this.findDeviceId('回风机2运行(开关)')].value,
          isError: __data[this.findDeviceId('回风机2运行(开关)')].errorLevel
        }
        this.SwitchStatusData16 = {
          data: __data[this.findDeviceId('回风机2故障(开关)')].value,
          isError: __data[this.findDeviceId('回风机2故障(开关)')].errorLevel,
          isZh: true
        }
        this.SwitchStatusData13 = {
          data: __data[this.findDeviceId('回风机3运行(开关)')].value,
          isError: __data[this.findDeviceId('回风机3运行(开关)')].errorLevel
        }
        this.SwitchStatusData14 = {
          data: __data[this.findDeviceId('回风机3故障(开关)')].value,
          isError: __data[this.findDeviceId('回风机3故障(开关)')].errorLevel,
          isZh: true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.prep-station-big {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: calc(100% - 60px) !important;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 3) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      flex-direction: column;
      .divice-block-time {
        height: 71%;
      }
    }
    .multi-item-tran {
      background-color: transparent;
    }
  }
  .divice-block-line {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 5) - 10px);
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      flex-direction: column;
      .divice-block-thin-wrap{
      background-color: rgba(255, 255, 255, 0.6);
      position: relative;
      &::after{
        content: ' ';
        position: absolute;
        width: 100%;
        top: 50%;
        height: 1px;
        background: #ddd;
      }
      .divice-block-thin{
        background: transparent;
      }
      }
      .divice-block-time {
        height: 42%;
      }
      .divice-block-time-big {
        height: 71%;
      }
    }
  }
}
</style>
